import { Check, Package } from "lucide-react";
import { STATUS_LABELS, WORKFLOW_STEPS, materialReceiptState } from "./workOrderTabUtils";

// Status workflow strip — Draft → Submitted → Approved → On Hand → Scheduled → Completed.
// Done steps are green ticks, the live step is blue, the rest are numbered grey. On Hand follows material
// receipt (green = all POs received, amber = partial). Shrinks on narrow screens and never wraps.
export function WOStatusWorkflow({ form, className = "" }) {
  const currentIdx = WORKFLOW_STEPS.indexOf(form.status === "cancelled" ? "draft" : form.status);
  const receipt = materialReceiptState(form.purchase_orders);
  return (
    <div className={`flex items-center flex-nowrap overflow-hidden ${className}`} data-testid="wo-status-workflow">
      {WORKFLOW_STEPS.map((step, idx) => {
        const isDone = idx < currentIdx;
        const isActive = idx === currentIdx;
        const isOnHand = step === "on_hand";
        const receiptGreen = isOnHand && receipt === "all";
        const receiptAmber = isOnHand && receipt === "partial";
        let circleCls = "bg-slate-200 text-slate-500";
        if (receiptGreen) circleCls = "bg-green-500 text-white";
        else if (receiptAmber) circleCls = "bg-amber-500 text-white";
        else if (isDone) circleCls = "bg-green-500 text-white";
        else if (isActive) circleCls = "bg-blue-600 text-white";
        let labelCls = "text-slate-400";
        if (receiptGreen) labelCls = "text-green-700";
        else if (receiptAmber) labelCls = "text-amber-700";
        else if (isActive) labelCls = "text-blue-700";
        else if (isDone) labelCls = "text-green-700";
        return (
          <div key={step} className={`flex items-center min-w-0 ${idx < WORKFLOW_STEPS.length - 1 ? "flex-1" : ""}`} data-testid={`wo-step-${step}`}>
            <div className={`flex items-center justify-center shrink-0 rounded-full font-bold w-5 h-5 text-[10px] sm:w-7 sm:h-7 sm:text-xs ${circleCls}`}
              data-testid={isOnHand ? `wo-step-on-hand-${receipt || "none"}` : undefined}
              title={isOnHand && receipt ? (receipt === "all" ? "All material received" : receipt === "partial" ? "Material partially received" : "No material received yet") : STATUS_LABELS[step]}>
              {receiptGreen ? <Check className="w-3 h-3 sm:w-4 sm:h-4" />
                : isOnHand ? <Package className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                : isDone ? <Check className="w-3 h-3 sm:w-4 sm:h-4" /> : idx + 1}
            </div>
            <span className={`ml-1 font-medium whitespace-nowrap text-[9px] sm:text-xs ${labelCls} ${isActive ? "" : "hidden sm:inline"}`}>
              {STATUS_LABELS[step]}
            </span>
            {idx < WORKFLOW_STEPS.length - 1 && (
              <div className={`flex-1 h-0.5 min-w-[8px] mx-1 sm:mx-2 ${isDone ? "bg-green-400" : "bg-slate-200"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
